// extracted by mini-css-extract-plugin
export default {"selectClass":"css_selectClass__j1Wy1","mainDiv":"css_mainDiv__cLRk0","labelClass":"css_labelClass__Nc79M","inputClass":"css_inputClass__dNXTV"};